module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/i18next/index.js
// module id = 553
// module chunks = 0